import { api } from "./axios";

export interface Church {
  id: string;
  name: string;
  slug: string;
  timezone: string;

  city: string | null;
  state: string | null;
}

export async function getChurchById(
  churchId: string
): Promise<Church> {
  const response = await api.get<Church>(
    `/api/churches/${churchId}`
  );

  return response.data;
}